import { WebsiteKind } from 'src/orchd-client';

export const isWebsiteNormalOrStaging = (kind: WebsiteKind | undefined) =>
  !!kind && [WebsiteKind.normal, WebsiteKind.staging].includes(kind);
